module.exports = __webpack_public_path__ + "media/images/swiss/offers/digital-voucher@2x-7b0ce700c5404c5a4d6071a7f12851d7.jpg";